import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { FaviconSwitchComponent } from 'src/app/shared/components/base-reset-password/favicon-switch.component';

@Component({
  selector: 'app-dr-dish-register-send',
  templateUrl: './dr-dish-register-send.component.html',
  styleUrls: ['../style/global.css', './dr-dish-register-send.component.css'],
  encapsulation: ViewEncapsulation.None,
})
export class DrDishRegisterSendComponent
  extends FaviconSwitchComponent
  implements OnInit
{
  initialized = false;
  constructor(title: Title) {
    super();
    title.setTitle('認証用URL送信完了 | Dr.Dish 医療・栄養サポート™');
  }

  ngOnInit(): void {
    setTimeout(() => {
      this.initialized = true;
    }, 1000);
  }
}
